import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetDataFlowDeviceDetailsSchemaResData extends ApiGenericResponse {
    deviceDetailsSchema: {};

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) this.deviceDetailsSchema = response.data.Payload;
    }
}
